import { useEffect } from 'react';
import { EMAIL_VERIFICATION_LINK } from 'constants/links';
import { useCurrentUser } from 'customHooks/useCurrentUser';

export const useRedirectUnverifiedUser = () => {
    const currentUser = useCurrentUser();

    useEffect(() => {
        if (currentUser.requiresVerification && !currentUser.isEmailVerified) {
            window.location.href = EMAIL_VERIFICATION_LINK;
        }
    }, [currentUser]);
};
